import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeView.vue'
import FAQ from '../views/FAQView.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home },
  { path: '/faq', component: FAQ }
]

export default new VueRouter({
  mode: 'history',
  routes
})